import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-tabs',
  templateUrl: './main-tabs.component.html',
  styleUrls: ['./main-tabs.component.scss'],
})
export class MainTabsComponent implements OnInit {
  constructor() {}

  public ngOnInit() {}
}
